function IconClose() {
  return (
    <svg viewBox="0 0 30 30" width={30} height={30}>
      <line x1="7" y1="7" x2="23" y2="23" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></line> <line x1="23" y1="7" x2="7" y2="23" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></line>
    </svg>
  );
}

export default IconClose;
